import 'theme/moydom/less/pages/landing-requests.less';
import 'bootstrap';
import $ from 'jquery';
import SwiperAdvantagesImageSlider from 'modules/widget/swiper/advantages-image-slider';

class SearchForm {
    init($form) {
        this.$input = $form.find('input');
        $form
            .find('button')
            .on('click', () => this.handlerClick(this.$input.val()));
    }

    handlerClick(value) {
        $.ajax({
            url: '/requests/search-problem-number/' + value,
            success: (data) => {
                if (data.redirect) {
                    document.location = data.redirect;
                } else {
                    this.handlerShowNotFoundModal(value);
                }
            },
        });
    }

    handlerShowNotFoundModal(number) {
        $('#modal-problem-not-found').modal('show');
    }
}

$(() => {
    new SearchForm().init($('.js-search-problem-by-number'));

    const swiperAdvantagesImageSlider = new SwiperAdvantagesImageSlider().init();
});
